import { BrowserRouter, Routes, Route } from "react-router";
import LayoutMain from "./layouts/layout-main";
import LayoutAuth from "./layouts/layout-auth";

import DashboardPage from "./pages/dashboard";
import ReviewsPage from "./pages/reviews";
import CreateReviewPage from "./pages/create-review";
import EditReviewPage from "./pages/edit-review";
import ViewReviewPage from "./pages/view-review";
import ViewDraftReviewPage from "./pages/view-draft-review";
import DraftReviewsPage from "./pages/draft-reviews";
import FormsPage from "./pages/forms";
import ImportPage from "./pages/import";
import BrandingPage from "./pages/branding";
import TeamsPage from "./pages/teams";
import BillingPage from "./pages/billing";
import SettingsPage from "./pages/settings";
import SupportPage from "./pages/support";
import RoadmapPage from "./pages/roadmap";
import IndexRedirect from "./pages/index-redirect";
import LoginPage from "./pages/login";
import SignupPage from "./pages/signup";
import CompleteProfilePage from "./pages/complete-profile";
import CreateBrandPage from "./pages/create-brand";
import LayoutOnboarding from "./layouts/layout-onboarding";
import { AuthGuard } from "./modules/auth";
import OnboardingGuard from "./modules/auth/components/onboarding-guard";
import { SetupGuard } from "./modules/auth";
import WorkspaceMemberGuard from "./modules/auth/components/workspace-member-guard";
import AuthValidatePage from "./pages/auth-validate";
import PublicGuard from "./modules/auth/components/public-guard";
import AuthFailurePage from "./pages/auth-failure";
import LayoutGlobal from "./layouts/layout-global";
import BrandsPage from "./pages/brands";
import ProfilePage from "./pages/profile";
import TagsPage from "./pages/tags";
import RoleGuard from "./modules/auth/components/role-guard";
import FeedbackPage from "./pages/feedback";
import LayoutFeedback from "./layouts/layout-feedback";
import LayoutWallOfLove from "./layouts/layout-wall-of-love";
import WallOfLovePage from "./pages/wall-of-love";
import WallOfLoveLightPage from "./pages/wall-of-love-light";
import WallOfLoveEditPage from "./pages/wall-of-love-create";
import WallOfLovePublicPage from "./pages/wall-of-love-public";
import WallOfLoveLightPublicPage from "./pages/wall-of-love-light-public";
import SharesPage from "./pages/shares";
import FormBuilderPage from "./pages/form-builder";
import WidgetsPage from "./pages/widgets";
import WidgetBuilderPage from "./pages/widget-builder";
import FormBuilderDemoPage from "./pages/form-builder-demo";
import NotFoundPage from "./pages/not-found";
import UpgradeModalProvider from "./components/upgrade-modal-provider";

export default function AppRoutes() {
	return (
		<BrowserRouter>
			<UpgradeModalProvider />
			<Routes>
				{/* ---------- PUBLIC ---------- */}
				<Route element={<PublicGuard />}>
					<Route element={<LayoutAuth />}>
						<Route index element={<IndexRedirect />} />
						<Route path="login" element={<LoginPage />} />
						<Route path="signup" element={<SignupPage />} />
						<Route path="auth/validate" element={<AuthValidatePage />} />
						<Route path="auth/failure" element={<AuthFailurePage />} />
					</Route>
				</Route>

				{/* ---------- PUBLIC FEEDBACK ---------- */}
				<Route element={<LayoutFeedback />}>
					<Route path="feedback" element={<FeedbackPage />} />
				</Route>

				{/* ---------- PUBLIC WALL OF LOVE ---------- */}
				<Route element={<LayoutWallOfLove />}>
					<Route path="wall-of-love-public" element={<WallOfLovePublicPage />} />
					<Route path="wall-of-love-light-public" element={<WallOfLoveLightPublicPage />} />
				</Route>

				{/* ---------- AUTHENTICATED ---------- */}
				<Route element={<AuthGuard />}>
					{/* Onboarding */}
					<Route element={<SetupGuard />}>
						<Route element={<LayoutOnboarding />}>
							<Route path="onboarding">
								<Route path="complete-profile" element={<CompleteProfilePage />} />
								<Route path="create-brand" element={<CreateBrandPage />} />
							</Route>
						</Route>
					</Route>

					{/* Post-onboarding */}
					<Route element={<OnboardingGuard />}>
						<Route element={<LayoutGlobal />}>
							<Route path="brands" element={<BrandsPage />} />
							<Route path="profile" element={<ProfilePage />} />
							{/* <Route path="ui-showcase" element={<UIShowcasePage />} />
							<Route path="widget-showcase" element={<WidgetShowcasePage />} /> */}
						</Route>

						<Route element={<WorkspaceMemberGuard />}>
							{/* Full-screen editor pages (no sidebar) */}
							<Route path=":brandUrl/wall-of-love/create" element={<WallOfLoveEditPage />} />
							<Route path=":brandUrl/wall-of-love/:wallId/edit" element={<WallOfLoveEditPage />} />
							<Route path=":brandUrl/widgets/create" element={<WidgetBuilderPage />} />
							<Route path=":brandUrl/widgets/:widgetId/edit" element={<WidgetBuilderPage />} />
							<Route path=":brandUrl/form-builder-demo" element={<FormBuilderDemoPage />} />
							<Route path=":brandUrl/forms/:formId/edit" element={<FormBuilderPage />} />

							<Route element={<LayoutMain />}>
								<Route path=":brandUrl">
									<Route index element={<DashboardPage />} />
									<Route path="dashboard" element={<DashboardPage />} />
									<Route path="reviews" element={<ReviewsPage />} />
									<Route path="reviews/drafts" element={<DraftReviewsPage />} />
									<Route path="reviews/create" element={<CreateReviewPage />} />
									<Route path="reviews/:reviewId/draft" element={<ViewDraftReviewPage />} />
									<Route path="reviews/:reviewId" element={<ViewReviewPage />} />
									<Route path="reviews/:reviewId/edit" element={<EditReviewPage />} />
									<Route path="forms" element={<FormsPage />} />
									<Route path="import" element={<ImportPage />} />
									<Route path="tags" element={<TagsPage />} />
									<Route path="branding" element={<BrandingPage />} />
									<Route path="wall-of-love" element={<WallOfLovePage />} />
									<Route path="wall-of-love-light" element={<WallOfLoveLightPage />} />
									<Route path="shares" element={<SharesPage />} />
									<Route path="widgets" element={<WidgetsPage />} />
									<Route path="support" element={<SupportPage />} />
									<Route path="roadmap" element={<RoadmapPage />} />

									<Route element={<RoleGuard requiredRole="admin" />}>
										<Route path="teams" element={<TeamsPage />} />
										<Route path="settings" element={<SettingsPage />} />
										<Route path="billing" element={<BillingPage />} />
									</Route>

									{/* Catch-all for unavailable routes within brand */}
									<Route path="*" element={<NotFoundPage />} />
								</Route>
							</Route>
						</Route>
					</Route>
				</Route>
			</Routes>
		</BrowserRouter>
	);
}
